import _slicedToArray from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
/**
 * Gets the validation error message for a field from the errors object
 * Handles both direct field matches and nested field paths
 */
export var getFieldError = function getFieldError(fieldName, errors) {
  if (!errors) return undefined;
  if (errors[fieldName]) return errors[fieldName];
  var matchingError = Object.entries(errors).find(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 1),
      errorField = _ref2[0];
    return errorField.startsWith(fieldName + ".");
  });
  return matchingError === null || matchingError === void 0 ? void 0 : matchingError[1];
};